// auth

export const LOGIN = "/api/login/"
export const LOGOUT = "/api/auth/log-out"
export const REFRESH_TOKEN = "/api/token/refresh/"
export const LOGIN_NEW = '/api/Account/login'
//data
export const UPLOAD_STOCK = "/api/upload_files"
export const GET_STOCK = "/api/stock_trend/stocks"
export const SEARCH_STOCK = "/api/stock_trend/search/extender"
export const ADD_STOCK = "/api/stock_trend/stocks"
export const DELETE_STOCK = "/api/stock_trend/stocks"
export const GET_STOCK_BY_ID = "/api/stock_trend/stocks"
export const LIVE_STOCKS = "/api/stock_trend/stocks-live"
export const LOGS = "/api/tracker_logs"
export const DOWNLOAD_STOCKS = "/api/stock_trend/stocks/download-all"
export const DOWNLOAD_STOCKS_BYID = "/api/stock_trend/stocks/download"
export const FORGOT_PASSWORD = "/api/stock_trend/forgot-password"
export const CHANGE_PASSWORD = "/api/stock_trend/change-password"
export const UPLOAD_STOCK_NEW = "/api/Account/StockTracker"
export const GET_ALL_LOGS_NEW = "/api/Account/GetAllLogs"

